import { render, staticRenderFns } from "./InventoryViewLots.vue?vue&type=template&id=113e5c6c&scoped=true&"
import script from "./InventoryViewLots.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewLots.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryViewLots.vue?vue&type=style&index=0&id=113e5c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e5c6c",
  null
  
)

export default component.exports